/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EcrRemovalRequestDto
 */
export interface EcrRemovalRequestDto {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof EcrRemovalRequestDto
     */
    workflowInstanceId: string;
    /**
     * Organization Id for whose benefit the workflow is performed or the user works
     * @type {string}
     * @memberof EcrRemovalRequestDto
     */
    orgId: string;
    /**
     * User Id
     * @type {string}
     * @memberof EcrRemovalRequestDto
     */
    userId: string;
    /**
     * Full official name of the role
     * @type {string}
     * @memberof EcrRemovalRequestDto
     */
    oorTitle: string;
}

/**
 * Check if a given object implements the EcrRemovalRequestDto interface.
 */
export function instanceOfEcrRemovalRequestDto(value: object): boolean {
    if (!('workflowInstanceId' in value)) return false;
    if (!('orgId' in value)) return false;
    if (!('userId' in value)) return false;
    if (!('oorTitle' in value)) return false;
    return true;
}

export function EcrRemovalRequestDtoFromJSON(json: any): EcrRemovalRequestDto {
    return EcrRemovalRequestDtoFromJSONTyped(json, false);
}

export function EcrRemovalRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EcrRemovalRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'],
        'orgId': json['orgId'],
        'userId': json['userId'],
        'oorTitle': json['oorTitle'],
    };
}

export function EcrRemovalRequestDtoToJSON(value?: EcrRemovalRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
        'orgId': value['orgId'],
        'userId': value['userId'],
        'oorTitle': value['oorTitle'],
    };
}

